import { useDispatch } from 'react-redux';
import { UserLaneEvents } from '../main/constants/UserLaneEvents';
import { updateTourStatus } from '../main/store/UserLane/actions/updateTourStatus';
import { sendDataTrackerEventHandler } from '../main/dataTracker/DataTrackerHelper';
import { DataTrackerEvents } from '../main/dataTracker/DataTrackerEvents';
import { AcceptedExtraData } from '@signaturit/data-tracker-client';

export interface IUseUserLaneExports {
    subscribeToNotifyOnComplete: () => void;
}

export const useUserLane = (): IUseUserLaneExports => {
    const userLaneClient: (event: string, action: string | Function) => void = window.Userlane;
    const dispatch = useDispatch();

    const subscribeToNotifyOnComplete = () => {
        userLaneClient(UserLaneEvents.OnComplete, async (userlaneId: string, user: any) => {
            const trackerData = { userlaneId, userlaneUser: user };
            sendDataTrackerEventHandler(DataTrackerEvents.HasCompletedTour, trackerData, [AcceptedExtraData.limits]);
            await dispatch(updateTourStatus(userlaneId));
        });
    };

    return {
        subscribeToNotifyOnComplete,
    };
};
